/**
 * The three paper records side by side, with their checkpoints (research/spx_1000am/FORWARD_GATES.md):
 * the frozen bull put (500), the ordinary-day bull put (250) and D0 (150). Checkpoints can only reject a record;
 * a pass is decided at the target.
 */

export function forwardRows(data) {
  const pb = data?.paper_bullput;
  const d0 = data?.paper_d0;
  const rows = [];
  if (pb) {
    const s = pb.summary || {};
    rows.push({ key: "frozen", name: "Frozen 0.9% bull put", settled: s.settled ?? 0, mean: s.mean, ci95: s.ci95, total: s.total,
      drawdown: s.max_drawdown, gates: s.gates, target: s.judge_at ?? 500 });
    const o = pb.flags?.ordinary_record;
    if (o) {
      rows.push({ key: "ordinary", name: "Ordinary-day bull put", settled: o.trades ?? 0, mean: o.mean, ci95: o.ci95, total: o.total,
        drawdown: o.max_drawdown, gates: o.gates, target: o.judge_at ?? 250 });
    }
  }
  if (d0) {
    const s = d0.summary || {};
    rows.push({ key: "d0", name: "D0", settled: s.settled ?? 0, mean: s.mean, ci95: s.ci95, total: s.total,
      drawdown: s.max_drawdown, gates: s.gates, target: s.judge_at ?? 150 });
  }
  return rows;
}

export function gateStatus(g) {
  if (!g) return { label: "—", tone: undefined };
  if (g.rejected) return { label: g.status, tone: "down" };
  if (g.settled >= g.target) return { label: "At target: judged by the rule", tone: "brand" };
  return { label: `Continue · next at ${g.next}`, tone: undefined };
}

export function shortHash(h) {
  return h ? `${h.slice(0, 8)}…${h.slice(-4)}` : "—";
}
